<template>
  <aside class="contract-contact-float" v-if="contact">
    <!-- 默认悬浮轻量胶囊按钮 -->
    <div
      class="contact-trigger-pill"
      @mouseenter="hovering = true"
      @mouseleave="hovering = false"
      @click="open = !open"
    >
      <i class="el-icon-service service-icon"></i>
      <span class="pill-text">专属顾问</span>
      <span class="online-indicator"></span>

      <!-- 悬停/点击展开的专属顾问详情卡片 -->
      <transition name="fade-slide">
        <div class="contact-card" v-if="open || hovering" @click.stop>
          <!-- 顾问身份行 -->
          <div class="card-header">
            <div class="avatar-circle">
              {{ consultantInitial }}
            </div>
            <div class="info-meta">
              <div class="name-title">{{ contact.name || "大客户经理" }}</div>
              <div class="role-desc">专属采购技术顾问</div>
            </div>
          </div>

          <!-- 微信二维码区域 (如果有二维码图片) -->
          <div class="qr-section" v-if="contact.qrCodeUrl">
            <div class="qr-wrap">
              <img :src="contact.qrCodeUrl" alt="微信二维码" class="qr-img" />
            </div>
            <span class="qr-hint">扫码微信 快速响应</span>
          </div>

          <!-- 专属热线电话 (如果有电话) -->
          <a
            class="phone-call-btn"
            v-if="contact.phone"
            :href="`tel:${contact.phone}`"
            title="拨打专属热线"
          >
            <i class="el-icon-phone phone-icon"></i>
            <span>{{ contact.phone }}</span>
          </a>
        </div>
      </transition>
    </div>
  </aside>
</template>

<script>
export default {
  name: "ContractContactFloat",
  props: {
    contact: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      open: false,
      hovering: false,
    };
  },
  computed: {
    consultantInitial () {
      if (this.contact && this.contact.name) {
        return this.contact.name.trim().charAt(0);
      }
      return "顾";
    },
  },
};
</script>

<style scoped lang="less">
@import '../assets/css/var.less';

.contract-contact-float {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 50;

  .contact-trigger-pill {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background-color: #0f172a;
    color: #ffffff;
    border-radius: 9999px;
    box-shadow: 0 4px 16px rgba(15, 23, 42, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.15);
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease;

    &:hover {
      background-color: #000000;
      box-shadow: 0 6px 20px rgba(15, 23, 42, 0.35);
      transform: translateY(-2px);
    }

    .service-icon {
      font-size: 16px;
      color: #60a5fa;
    }

    .pill-text {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.02em;
    }

    .online-indicator {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background-color: #10b981;
      box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.3);
    }
  }

  // 展开的顾问卡片
  .contact-card {
    position: absolute;
    right: 0;
    bottom: calc(100% + 12px);
    width: 230px;
    background-color: #ffffff;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.05);
    border: 1px solid @brandBorder;
    padding: 16px;
    box-sizing: border-box;
    cursor: default;

    .card-header {
      display: flex;
      align-items: center;
      gap: 12px;
      padding-bottom: 12px;
      border-bottom: 1px solid @brandBorderLight;

      .avatar-circle {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background-color: @brandLight;
        color: @brandContainer;
        font-weight: 700;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(15, 82, 186, 0.15);
        flex-shrink: 0;
      }

      .info-meta {
        .name-title {
          font-size: 14px;
          font-weight: 600;
          color: @brandTextDark;
          line-height: 1.2;
        }

        .role-desc {
          font-size: 11px;
          color: @brandTextLight;
          margin-top: 3px;
        }
      }
    }

    .qr-section {
      padding: 14px 0 10px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .qr-wrap {
        width: 110px;
        height: 110px;
        background-color: #f8fafc;
        border: 1px solid @brandBorder;
        border-radius: 8px;
        padding: 4px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        .qr-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .qr-hint {
        font-size: 11px;
        color: @brandTextMuted;
        margin-top: 8px;
      }
    }

    .phone-call-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      width: 100%;
      padding: 8px 12px;
      border-radius: 8px;
      background-color: @brandLight;
      color: @brandPrimary;
      font-size: 12px;
      font-weight: 600;
      text-decoration: none;
      border: 1px solid rgba(15, 82, 186, 0.15);
      box-sizing: border-box;
      transition: all 0.15s ease;

      &:hover {
        background-color: @brandContainer;
        color: #ffffff;
      }

      .phone-icon {
        font-size: 14px;
      }
    }
  }

  // 动画
  .fade-slide-enter-active,
  .fade-slide-leave-active {
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .fade-slide-enter,
  .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(8px) scale(0.96);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContractContactFloat.vue